import { t } from '@lingui/core/macro';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type PaginationProps = ComponentProps<'nav'>;

const Pagination = ({ className, ...props }: PaginationProps) => {
  return (
    <nav
      role="navigation"
      aria-label={t`Pagination`}
      data-slot="pagination"
      className={cn('mx-auto flex w-full justify-center', className)}
      {...props}
    />
  );
};

export default Pagination;
